export default __webpack_public_path__ + "static/media/centrica-logo.2bdfeeb3.png";